module.exports = __webpack_public_path__ + "media/GIS理论基础.a148c82c.mp4";